export const getIntentLanguageStyles = () => ({
  intentTarget: {
    marginTop: 20,
    '& .select-language-label-container': {
      marginBottom: '18px',
    },
    '& .multi-language-selector-container': {
      marginTop: '18px',
    },
  },
  intentTargetOptions: {
    marginTop: 6,
  },
});
